import { Navigate } from 'react-router';
import { CalendarClock } from 'lucide-react';
import type { ModuloWeb } from '../../nucleo/modulos-web';
import { i18n } from './i18n';
import { Recursos } from './Recursos';
import { Reunioes } from './Reunioes';
import { VisaoAgenda } from './VisaoAgenda';
import { buscaAgenda } from './busca-global';
import { criacoesAgenda } from './criacoes';
import { CartaoMinhaAgendaGoogle } from './MinhaAgendaGoogle';

const modulo: ModuloWeb = {
  slug: 'agenda',
  menu: 'agenda',
  ordem: 10,
  abas: [
    { chave: 'semana', permissao: 'agenda.ver', componente: () => <VisaoAgenda key="semana" visao="semana" /> },
    { chave: 'dia', permissao: 'agenda.ver', componente: () => <VisaoAgenda key="dia" visao="dia" /> },
    { chave: 'mes', permissao: 'agenda.ver', componente: () => <VisaoAgenda key="mes" visao="mes" /> },
    // Fase 2 (W6, L1): Profissionais e recursos moram em Cadastros (o dado continua da Agenda).
    { chave: 'recursos', permissao: 'agenda.ver', componente: Recursos, menu: 'cadastros', grupo: 'agenda', posicao: 100 },
  ],
  // Fase 2 (W18, K2): a aba Serviços saiu; a Agenda agenda pelo catálogo único (Cadastros > Serviços). Link e favorito
  // antigos vão para lá.
  rotasExtras: [{ caminho: 'servicos/*', componente: () => <Navigate to="/cadastros/cadastros/servicos" replace /> }],
  // CRM no novo desenho (lote 1, C-E): Reuniões/Agenda do clone do RD, página do CRM na casca nova (sobre o agendamento).
  // Lote crm8 (item 5): na visualização da Agenda (Semana, Dia, Mês), no lugar do menu Agenda do sub-sistema (uma tela só).
  paginasCasca: [{ chave: 'reunioes', caminho: 'crm/reunioes', componente: Reunioes, permissao: 'agenda.ver', pagina: 'agenda.semana', icone: CalendarClock, posicao: 30, substituiMenu: 'agenda' }],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaAgenda,
  // Rodada rrl-1 (SPEC-M1): "Criar reunião" no botão flutuante do CRM, com o vínculo da ficha aberta.
  criacoes: criacoesAgenda,
  // Lista 30/10 B (item 34): Minha conta > Perfil > Google Agenda (o da própria pessoa).
  cartaoMinhaConta: CartaoMinhaAgendaGoogle,
};

export default modulo;
